import { IPromise, IQService } from 'angular';

export interface BankAccountCreationPolicy {
    CountryID: number;
    routingNumberLength: number;
    institutionNumberLength: number;
    requireInstitutionNumber: boolean;
    supportAdpDirectDepositForm: boolean;
    routingNumberLabel: string;
    institutionNumberLabel: string;
    voidCheckLabel: string;
}

const POLICIES: BankAccountCreationPolicy[] = [
    {
        CountryID: 1,
        routingNumberLength: 9,
        institutionNumberLength: 0,
        requireInstitutionNumber: false,
        supportAdpDirectDepositForm: true,
        routingNumberLabel: "Routing Number",
        institutionNumberLabel: "Institution Number",
        voidCheckLabel: "Void Check"
    },
    {
        CountryID: 2,
        routingNumberLength: 5,
        institutionNumberLength: 3,
        requireInstitutionNumber: true,
        supportAdpDirectDepositForm: false,
        routingNumberLabel: "Routing Number",
        institutionNumberLabel: "Institution Number",
        voidCheckLabel: "Void Check"
    }];

export class BankAccountCreationPolicyService {
    constructor(private $q: IQService) {
        'ngInject'
    }

    retrievePolicyByCountryID(countryID: number): IPromise<BankAccountCreationPolicy> {
        return this.$q.resolve(POLICIES.find(policy => policy.CountryID === countryID))
    }
}
